<table [class]="cssClass">
  <ng-content></ng-content>
</table>
